function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm4.324 3.5H8.713A9.838 9.838 0 0 0 7.3 1.178 5.016 5.016 0 0 1 10.324 3.5zM8.25 6a5.106 5.106 0 0 1-.238 1.5H3.988A5.106 5.106 0 0 1 3.75 6a5.105 5.105 0 0 1 .238-1.5h4.024A5.105 5.105 0 0 1 8.25 6zM4.389 8.5h3.222A9.807 9.807 0 0 1 6 10.794 9.785 9.785 0 0 1 4.389 8.5zm0-5A9.807 9.807 0 0 1 6 1.206 9.785 9.785 0 0 1 7.611 3.5zM4.7 1.178A9.838 9.838 0 0 0 3.287 3.5h-1.61A5.015 5.015 0 0 1 4.7 1.178zM1.231 4.5H2.95a6.008 6.008 0 0 0-.2 1.5 6.008 6.008 0 0 0 .2 1.5H1.231a5 5 0 0 1 0-3zm.446 4h1.61A9.838 9.838 0 0 0 4.7 10.822 5.015 5.015 0 0 1 1.677 8.5zM7.3 10.822A9.838 9.838 0 0 0 8.713 8.5h1.611A5.015 5.015 0 0 1 7.3 10.822zM10.77 7.5H9.05a6.008 6.008 0 0 0 .2-1.5 6.008 6.008 0 0 0-.2-1.5h1.719a5 5 0 0 1 0 3z",
    style: {
      fill: "#050505"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.1ad4b83ffaa6761593bd52e39df066ab.svg";
export { ForwardRef as ReactComponent };